import { render, staticRenderFns } from "./FirstAgentTcRecordList.vue?vue&type=template&id=4bb86d56&"
import script from "./FirstAgentTcRecordList.vue?vue&type=script&lang=js&"
export * from "./FirstAgentTcRecordList.vue?vue&type=script&lang=js&"
import style0 from "./FirstAgentTcRecordList.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports